import axios from 'axios';
import { getCookie } from 'cookies-next';

const API_BASE_URL = import.meta.env.VITE_API_URL;
console.log(API_BASE_URL)
const httpClient = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
  baseURL: API_BASE_URL,
});

// Request interceptor to add the auth token
httpClient.interceptors.request.use(
  (config) => {
    const authSessionCookie = getCookie('_Edunav_AUTH_KEY_');
    if (authSessionCookie) {
      try {
        const authSession = JSON.parse(authSessionCookie);
        if (authSession?.token) {
          config.headers['Authorization'] = `Bearer ${authSession.token}`;
        }
      } catch (error) {
        console.error("Failed to parse auth session cookie:", error);
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


export default httpClient;
